import { Container } from 'inversify-props';
import TYPES from './types';

// infrastructure
import CustomerOverviewHttpRepository from './infrastructure/repositories/customer-overview-http-repository';
import {
  CustomerOverviewVueStateManager,
} from '@/modules/home-dashboard/customer-overview/infrastructure/state/customer-overview-vue-state-manager';

// application
import GetCustomerOverviewQuery from './application/queries/get-customer-overview-query';
import CustomerOverviewService from './application/services/customer-overview-service';

// domain
import { CustomerOverviewRepository } from './domain/repositories/customer-overview-repository';
import {
  CustomerOverviewStateManager,
} from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state-manager';

export default function setupCurrentUser(container: Container) {
  container
    .bind<CustomerOverviewStateManager>(TYPES.CUSTOMER_OVERVIEW_STATE_MANAGER)
    .to(CustomerOverviewVueStateManager)
    .inSingletonScope();

  container
    .bind<CustomerOverviewRepository>(TYPES.CUSTOMER_OVERVIEW_REPOSITORY)
    .to(CustomerOverviewHttpRepository)
    .inSingletonScope();

  container
    .bind<GetCustomerOverviewQuery>(TYPES.GET_CUSTOMER_OVERVIEW_QUERY)
    .to(GetCustomerOverviewQuery)
    .inSingletonScope();

  container
    .bind<CustomerOverviewService>(TYPES.CUSTOMER_OVERVIEW_SERVICE)
    .to(CustomerOverviewService)
    .inSingletonScope();
}
